<mat-card>
    <mat-card-title>Login</mat-card-title>
    <mat-card-content>
        <div class="button-container">
            <button (click)="loginWithGoogle()" mat-raised-button class="google-login-btn">
                Login with Google
            </button>
        </div>
    </mat-card-content>
</mat-card>